<template>
  <div class="Fade" :class="{ 'Fade_visible': isShow }">
    <slot></slot>
  </div>
</template>

<script>
  import scrollUpdate from '@/mixins/scrollUpdate'

  export default {
    mixins: [ scrollUpdate ],
    props: [ 'delay' ],
    data() {
      return {
        isShow : false
      }
    },
    methods: {
      onVisible()
      {
        if(this.isShow) return

        setTimeout( () => {
          this.isShow  = true
        }, this.delay )
      },
    }
  }
</script>

<style lang="stylus" scoped>
.Fade

  opacity 0
  transition 1s 0.3s $ease

  &_visible

    opacity 1
</style>